import { useCallback, MouseEvent } from 'react';
import { NavLink } from 'react-router-dom';
import type { ITabData } from './tabType';

const TabItem = ({ data }: { data: ITabData }) => {
  const { type, title, url, clickCallback } = data || {};

  const linkClickCallback = useCallback(
    (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
      const locationPathname = location.pathname || '';
      const urlPathname = new URL(url, location.href)?.pathname || '';

      // 동일한 pathname이면 리로드하지 않음
      if (locationPathname.includes(urlPathname)) {
        e.preventDefault();
        return false;
      }

      typeof clickCallback === 'function' && clickCallback(e);
    },
    [url]
  );

  switch (type) {
    case 'ROUTE':
      return (
        <NavLink to={url} className={({ isActive }) => (isActive ? 'active' : '')} onClick={linkClickCallback}>
          {title}
        </NavLink>
      );
    case 'BUTTON':
      return (
        <button type="button" onClick={linkClickCallback}>
          {title}
        </button>
      );
    default:
      return (
        <a href={url} onClick={linkClickCallback}>
          {title}
        </a>
      );
  }
};

export default TabItem;
